import {
  FavoriteItemOpenedEvent,
  TelemetryEvents
} from '../../common/telemetryEvents/TelemetryEvents';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { FavoriteItemType } from '../../ts/ServerApi/types/IFavorite';
import { Telemetry } from '../../ts/services/TelemetryService';

export function maybeSendTelemetry_favoriteItemOpened(telemetry: Telemetry, item: IContentInfo<FavoriteItemType>) {
  if (item.favorite) {
    telemetry.sendEvent<FavoriteItemOpenedEvent>({
      type: TelemetryEvents.FavoriteItemOpened,
      favoriteItemType: item.contentType,
      favoriteItemId: item.id,
    });
  }
}
